import { AccountingReportsRepositoryImplementation } from '../infrastructure/accounting-reports-repository-implementation';
import { ReportDefinitionBase, ReportGenerateRequest } from '../domain/accounting_reports/model';
import { EmptyArray } from "../domain/empty/model";

import { cacheManager } from '../infrastructure/cache-manager';

const repo = new AccountingReportsRepositoryImplementation('', null); // uid and cid will need to be handled

// Cache key prefix
const CACHE_PREFIX = 'accounting_reports_available_v4';

async function getAvailableReports(): Promise<ReportDefinitionBase[] | typeof EmptyArray> {
  try {
    const cached = cacheManager.getItem<ReportDefinitionBase[]>(CACHE_PREFIX);
    if (cached) {
      console.log('Returning available reports from cache');
      return cached;
    }

    const result = await repo.getAvailableReports().toPromise();
    if (!result || result.length === 0) {
      return EmptyArray;
    }

    cacheManager.setItem(CACHE_PREFIX, result);
    return result;
  } catch (error) {
    console.error('Error fetching available reports:', error);
    throw error;
  }
}

async function generateAccountingReport(request: ReportGenerateRequest): Promise<string> {
  try {
    const result = await repo.generateReport(request).toPromise();
    if (result === undefined) {
      throw new Error('Report generation returned no data.');
    }
    // No cache invalidation needed for report generation as it's a one-off action
    return result;
  } catch (error) {
    console.error('Error generating report:', error);
    throw error;
  }
}

async function saveDailyClosure(data: any): Promise<any> {
  try {
    const result = await repo.saveDailyClosure(data).toPromise();
    if (result === undefined) {
      throw new Error('Save daily closure returned no data.');
    }
    return result;
  } catch (error) {
    console.error('Error saving daily closure:', error);
    throw error;
  }
}

export {
  getAvailableReports,
  generateAccountingReport,
  saveDailyClosure,
};
